import { CommonModule } from '@angular/common';
import {
    Component,
    ElementRef,
    inject,
    Input,
    signal,
    viewChild,
    WritableSignal,
} from '@angular/core';
import {
    EventInfo,
    IqEventBusTransformationService,
    ServiceConsumerEventName,
} from '../state/services';
import { unescape } from 'lodash';
@Component({
    selector: 'iq-event-bus-trigger',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './iq-event-bus-trigger.component.html',
    styleUrl: './iq-event-bus-trigger.component.scss',
})
export class IqEventBusTriggerComponent {
    @Input()
    name: string;

    @Input()
    payload: string;

    @Input()
    class: string;

    @Input()
    id: string = '';

    @Input()
    testId: string = '';

    private _transform: IqEventBusTransformationService = inject(
        IqEventBusTransformationService,
    );

    templateWrapper = viewChild<ElementRef<HTMLDivElement>>('templateWrapper');
    renderedWrapper = viewChild<ElementRef<HTMLDivElement>>('renderedWrapper');

    loaded: WritableSignal<boolean> = signal(false);
    template: WritableSignal<string> = signal('');
    currentTestId: string = '';
    button = viewChild<ElementRef>('trigger');

    constructor() {
        this.currentTestId = !!this.testId?.length ? this.testId : this.id;

        setTimeout(() => {
            this.render();
        });
    }

    triggerEvent() {
        try {
            const event: EventInfo = {
                name: this.name,
                payload: JSON.parse(this.payload),
            };

            window.dispatchEvent(
                new CustomEvent<EventInfo>(ServiceConsumerEventName, {
                    detail: event,
                }),
            );
        } catch (error) {
            console.error(error);
        }
    }

    private render(payload: any = {}) {
        const template = unescape(
            this.templateWrapper().nativeElement.innerHTML.trim(),
        );
        const html = this._transform.render(template, {
            payload,
        });

        this.renderedWrapper().nativeElement.innerHTML = html;
    }
}
